"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return NotificationsContainer;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _helpers = require("../helpers");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function NotificationsContainer({ notifications, componentMap, styles, onUnknownComponent }) {
    const [dismissed, setDismissed] = (0, _react.useState)(new Set());
    const handleDismiss = (0, _react.useCallback)((id)=>{
        setDismissed((prev)=>new Set(prev).add(id));
    }, []);
    const activeNotifications = (0, _react.useMemo)(()=>notifications.filter((n)=>!dismissed.has(n.id)), [
        notifications,
        dismissed
    ]);
    const components = (0, _react.useMemo)(()=>{
        const mappedComponents = [];
        for (const notification of activeNotifications){
            const Component = componentMap[notification.id];
            if (Component) {
                mappedComponents.push(/*#__PURE__*/ _react.default.createElement(Component, {
                    key: notification.id,
                    onClose: ()=>handleDismiss(notification.id),
                    data: notification.data
                }));
            } else {
                onUnknownComponent === null || onUnknownComponent === void 0 ? void 0 : onUnknownComponent(notification.id);
            }
        }
        return mappedComponents;
    }, [
        activeNotifications,
        componentMap,
        handleDismiss,
        onUnknownComponent
    ]);
    if (components.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: (0, _helpers.getClassName)('NotificationCenter', styles)
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: (0, _helpers.getClassName)('NotificationCenter__List', styles)
    }, components));
}

//# sourceMappingURL=Notifications.js.map